module.exports = __webpack_public_path__ + "media/images/story-f-b59f61535b623040a3abc088f189e03e.png";